import React from 'react';
import {Microlesson} from '../../../data/models/Microlessons/Microlesson';
import {logoTextWhite} from '../../../assets/images';

interface Props {
  lesson: Microlesson;
  onSelectLesson: (lesson: Microlesson) => void;
  selected: boolean;
}

const MicrolessonsLibraryCard = React.memo(
  ({lesson, onSelectLesson, selected}: Props) => {
    return (
      <div
        className="MicrolessonLibraryCard"
        onClick={() => onSelectLesson(lesson)}>
        <div className="Poster">
          {lesson.poster ? (
            <img src={lesson.poster} />
          ) : (
            <img src={logoTextWhite} className="PlaceholderLogo" />
          )}
        </div>
        <div className="InfoContainer">
          <p>{lesson.title}</p>
        </div>
        {selected && (
          <div className="SelectedMicrolessonOverlay">
            <div className="CheckContainer">
              <span className="icon-check"></span>
            </div>
          </div>
        )}
      </div>
    );
  },
);

export default MicrolessonsLibraryCard;
